// the former ClosingTimeType NO_FOOD no longer exists.
export type ClosingTimeType = "HOLIDAY" | "PUBLIC_HOLIDAY";

export type ClosingTime = {
  "@id": string;
  "@type": string;
  id: number;
  name: string;
  startDate: `${number}-${number}-${number}`;
  endDate: `${number}-${number}-${number}`;
  type?: ClosingTimeType;
  comment?: string;
  schoolClass?: string;
  editedBy?: string;
};
